<div class="app-container">
  <header>
    <app-navbar></app-navbar>
  </header>
  <app-banner-contact></app-banner-contact>
  <main class="main-content">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>
